import produce from 'immer';
import {
  GET_DEPOSIT_LIST_START,
  GET_DEPOSIT_LIST_SUCCESS,
  GET_DEPOSIT_LIST_FAILED,
  GET_DEPOSIT_BY_ID_START,
  GET_DEPOSIT_BY_ID_SUCCESS,
  GET_DEPOSIT_BY_ID_FAILED,
  GET_DEPOSIT_PAYMENT_BY_ID_START,
  GET_DEPOSIT_PAYMENT_BY_ID_SUCCESS,
  GET_DEPOSIT_PAYMENT_BY_ID_FAILED,
  EDIT_DEPOSIT_START,
  EDIT_DEPOSIT_SUCCESS,
  EDIT_DEPOSIT_FAILED,
  EDIT_DEPOSIT_PAYMENT_START,
  EDIT_DEPOSIT_PAYMENT_SUCCESS,
  EDIT_DEPOSIT_PAYMENT_FAILED,
} from 'redux/actions/deposits';


const initialState = {
  depositsList: [],
  isDepositsLoading: false,
  depositsTotalCount: 0,
  editableDeposit: {},
  editableDepositPayment: {},
  isDepositLoading: false,
  isDepositPaymentLoading: false
};

const formReducer = produce((state: IDepositsState = initialState, action) => {
  switch (action.type) {
    case GET_DEPOSIT_LIST_START: {
      state.isDepositsLoading = true;
      break;
    }

    case GET_DEPOSIT_LIST_SUCCESS: {
      const { items, total_count } = action.data.deposits;

      state.depositsList = items;
      state.depositsTotalCount = total_count;
      state.isDepositsLoading = false;
      break;
    }

    case GET_DEPOSIT_LIST_FAILED: {
      state.isDepositsLoading = false;
      break;
    }

    case GET_DEPOSIT_BY_ID_START: {
      state.isDepositLoading = true;
      break;
    }

    case GET_DEPOSIT_BY_ID_SUCCESS: {
      const { deposit } = action.data;

      state.editableDeposit = deposit;
      state.isDepositLoading = false;
      break;
    }

    case GET_DEPOSIT_BY_ID_FAILED: {
      state.isDepositLoading = false;
      break;
    }

    case GET_DEPOSIT_PAYMENT_BY_ID_START: {
      state.isDepositLoading = true;
      break;
    }

    case GET_DEPOSIT_PAYMENT_BY_ID_SUCCESS: {
      const { payment } = action.data;

      state.editableDepositPayment = payment;
      state.isDepositPaymentLoading = false;
      break;
    }

    case GET_DEPOSIT_PAYMENT_BY_ID_FAILED: {
      state.isDepositLoading = false;
      break;
    }

    case EDIT_DEPOSIT_START: {
      state.isDepositLoading = true;
      break;
    }

    case EDIT_DEPOSIT_SUCCESS: {
      const { deposit } = action.data;

      state.editableDeposit = deposit;
      state.isDepositLoading = false;
      break;
    }

    case EDIT_DEPOSIT_FAILED: {
      state.isDepositLoading = false;
      break;
    }

    case EDIT_DEPOSIT_PAYMENT_START: {
      state.isDepositPaymentLoading = true;
      break;
    }

    case EDIT_DEPOSIT_PAYMENT_SUCCESS: {
      const { payment } = action.data;

      state.editableDepositPayment = payment;
      state.isDepositPaymentLoading = false;
      break;
    }

    case EDIT_DEPOSIT_PAYMENT_FAILED: {
      state.isDepositPaymentLoading = false;
      break;
    }
  }
}, initialState);

export default formReducer;
